import { CurrencyPipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostBinding, HostListener, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import * as d3 from "d3";
import { FilterService } from 'src/app/services/filter.service';

@Component({
  selector: 'app-cluster-static-bar-chart',
  templateUrl: './cluster-static-bar-chart.component.html',
  styleUrls: ['./cluster-static-bar-chart.component.scss']
})
export class ClusterStaticBarChartComponent implements OnInit,AfterViewInit {
  @ViewChild('clusterStaticBarContainer', { static: true }) clusterStaticBarContainer!: ElementRef
  @ViewChild('clusterStaticBar', { static: true }) clusterStaticBar!: ElementRef
  @ViewChild('smallBarChart') smallBarChart!: ElementRef;
  @Input('data') data: any
  @Input('pageKey') pageKey: any
  @Input('item') item: any
  @Input('config') config: any
  @Input('headerConfig') headerConfig: any
  @Input('error_name') error_name: any;
  @Input('heading') heading: string = ''
  @ViewChild('fs') fs!: ElementRef;
  isActive = false;
  iconList: any[] = []
  @HostBinding('class.is-fullscreen') isFullscreen = false;
  SmallBarChartData: any;
  props: any;
  divId: any = "clusterStaticBarChartDiv";
  mytooltipData: any
  initiateChart: Boolean = false
  isTooltip: Boolean = false
  noData: Boolean = false
  dataTurn: any
  myType: any | undefined
    scrollLeft: any = 0;
  scrollWidth: any = 0
  scrollRight: any = 0
  @HostListener('fullscreenchange', ['$event'])
    @HostListener('webkitfullscreenchange', ['$event'])
    @HostListener('mozfullscreenchange', ['$event'])
    @HostListener('MSFullscreenChange', ['$event'])
    screenChange(event: any) {
      if (!document.fullscreenElement) {
        this.closeFullscreen();
      }
    }
  
    constructor(private filterService: FilterService, private currency: CurrencyPipe) {
      this.filterService.filterQuery.subscribe((query: any) => {
        this.start()
      })
    }
 fullscreenChanges(fullscreen:any){
    if(fullscreen==false){
      this.closeFullscreen()
      return
    }
    this.props.chartHeight = window.outerHeight - 60
    this.isFullscreen = fullscreen;
    this.isActive = fullscreen;
    this.plotChart()
}
  
    //loade Method
    isLoading = false;
    async stop(ms: number): Promise<void> {
      return new Promise<void>(resolve => setTimeout(resolve, ms));
    }
    start() { this.isLoading = true; }
  
    ngOnInit(): void {
      this.start()
      this.iconList = this.item.config.icon ? this.item.config.icon : this.iconList
      this.divId = this.item.config.divId+this.item.widget_uniq_key
      this.initiateCharts();
  
    }
    ngOnChanges(changes: SimpleChanges): void {
      if (changes['data'].currentValue != changes['data'].previousValue && this.initiateChart) {
        this.getSmallBarChartData();
      }
    }
      ngAfterViewInit(): void {
    this.scrollLeft = 0
    this.scrollWidth = 0
    this.scrollRight = 0
    document.getElementById('myChartContainer')?.addEventListener("scroll", (event: any) => {
      this.scrollLeft = event?.target?.scrollLeft
      this.scrollWidth = event?.target?.scrollWidth
      this.scrollRight = this.scrollWidth - this.scrollLeft
      console.log(this.scrollLeft, this.scrollWidth, this.scrollRight)
      if (this.scrollLeft == 0) {
        this.scrollRight = 0
        this.scrollWidth = 0
      }
    })
  }
    closeFullscreen(): void {
      this.isFullscreen = false;
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
      this.props.chartHeight =  500
      this.isActive = false;
      
      setTimeout(() => {
        this.plotChart()
      }, 100);
    }
  
    @HostListener("window:resize", ["$event"])
    onResize(event: Event) {
      setTimeout(() => {
        this.plotChart()
      }, 100);
    }
  
    height: any = 0
  private showTooltip(
  myType: any,
  myData: any,
  myX: number,
  myY: number,
  chartWidth: number,
  chartHeight: number
): void {
  this.myType = myType;
  this.mytooltipData = myData;
  this.height = chartHeight - myY;
  this.dataTurn = chartWidth - myX;

  const container = document.getElementById('myChartContainer');
  const scrollLeft = container?.scrollLeft || 0;
  const scrollTop = container?.scrollTop || 0;

  // adjusted positions with scroll
  const adjX = myX - scrollLeft;
  const adjY = myY - scrollTop;
console.log(adjX, adjY, this.dataTurn, this.height);
  const tooltip = d3
    .select(this.smallBarChart.nativeElement)
    .select("#d3SBarTooltip")
    .style("visibility", "visible")
    .style("position", "absolute");

  if (myType === "groupFullName") {
    tooltip.style("top", adjY + 25 + "px");

    if (this.dataTurn < 250) {
      tooltip.style("right", this.dataTurn + 20 + "px").style("left", "unset");
    } else {
      tooltip.style("left", adjX + 25 + "px").style("right", "unset");
    }
  } else {
    // vertical positioning
    if (this.height < 200) {
      tooltip.style("bottom", this.height - 60 + "px").style("top", "unset");
    } else {
      tooltip.style("top", adjY + 30 + "px").style("bottom", "unset");
    }

    // horizontal positioning
    if (this.dataTurn < 300) {
      tooltip.style("right", this.dataTurn + 20 + this.scrollLeft + "px").style("left", "unset");
    } else {
      tooltip.style("left", adjX + 25 + "px").style("right", "unset");
    }
  }

  this.isTooltip = true;
}

  
    private hideTooltip(myType: any): void {
      this.isTooltip = false
      // d3.select(this.smallBarChart.nativeElement).select("#d3SBarTooltip")
      // .style('visibility', 'hidden');
    }
    initiateCharts(): void {
    const myChart = this;
  const myClass = myChart.divId;

  const mySvg = d3.select(this.clusterStaticBar.nativeElement)
    .append('svg')
    .attr('id', 'svg_' + myClass)
    .style('background-color', 'white')
    .style('display', 'block');

  mySvg.append("g").attr("class", "xAxis" + myClass);
  mySvg.append("g").attr("class", "yAxis" + myClass);
   mySvg.append('g').attr('class', 'chartGroup' + myClass);
   mySvg.append('g').attr('class', 'miniChart' + myClass);
  mySvg.append('g').attr('class', 'brush' + myClass);
  this.initiateChart = true
}

plotChart(): void {
  const myChart: any = this;
  const myClass = myChart.divId;
  const mySvg: any = d3.select('#svg_' + myClass);
  const container: any = d3.select(this.clusterStaticBarContainer.nativeElement);
  const clientWidth = container.node().getBoundingClientRect().width;
  // const width = Math.max(500, clientWidth); // Minimum width for scroll
  // const height = this.props.chartHeight;
  let margins = { left: 45, right: 12, top: 30, bottom: 50 };

  mySvg.selectAll("*").remove();
  
  const groupVars:any = Array.from(new Set(myChart.SmallBarChartData.map((d: any) => d[myChart.props.groupVar])));
  const barVars:any = Array.from(new Set(myChart.SmallBarChartData.map((d: any) => d[myChart.props.barVar])));
  const stackVars:any = Array.from(new Set(myChart.SmallBarChartData.map((d: any) => d[myChart.props.stackVar])));
const groupCount = groupVars.length;
const barCount = barVars.length;
const barClusterWidth = 40 * barCount + 30;  // tune width per bar cluster
const requiredWidth = groupCount * barClusterWidth;

const width = Math.max(clientWidth, requiredWidth, 500); // dynamic width
const height = this.props.chartHeight;
mySvg.attr("width", width).attr("height", height);
  const groupedBarData: any[] = [];

  groupVars.forEach((group: string) => {
    barVars.forEach((bar: string) => {
      const filtered = myChart.SmallBarChartData.filter((d: any) => d[myChart.props.groupVar] === group && d[myChart.props.barVar] === bar);
      const barObj: any = { name: group + '_' + bar, group, bar };
      stackVars.forEach((s: string) => {
        barObj[s] = d3.sum(filtered, (d: any) => d[myChart.props.stackVar] === s ? d[myChart.props.yVar] : 0);
      });
      groupedBarData.push(barObj);
    });
  });

  const stackedData = d3.stack().keys(stackVars)(groupedBarData);
  let yMax:any = d3.max(stackedData, (d: any) => d3.max(d, (m: any) => m[1]));
  yMax = yMax * 1.1; // Ensure minimum height for visibility
  const yScale = d3.scaleLinear().domain([0, yMax]).range([height - margins.top - margins.bottom, 0]);
  const yScaleHeight = d3.scaleLinear().domain([0, yMax]).range([0, height - margins.top - margins.bottom]);

  const xGroupScale:any = d3.scaleBand().domain(groupVars).range([0, width - margins.left - margins.right]).padding(0.3);
  const xBarScale:any = d3.scaleBand().domain(barVars).range([0, xGroupScale.bandwidth()]).padding(0.2);

  const chartData: any[] = [];

  stackedData.forEach((stack: any, stackIndex: number) => {
    stack.forEach((d: any, i: number) => {
      const original = groupedBarData[i];
      const value = d[1] - d[0];
      const heightVal = yScaleHeight(value);
      const fill = myChart.props.stackEnable ? myChart.props.barFill[stack.key] || myChart.props.stackColors[stackIndex]: myChart.props.clusterColors[barVars.indexOf(original.bar)];;
     if(myChart.props.stackEnable){
      myChart.props.barFill[stack.key] = fill;
      myChart.props.barLabels[stack.key] = stack.key;
      }
      chartData.push({
        name: original.name,
        group: original.group,
        bar: original.bar,
        value,
        height: heightVal < 2 && value > 0 ? 2 : heightVal,
        fill,
        totalValue: d[1],
        extraY: heightVal < 2 && value > 0 ? 2 - heightVal : 0,
        borderRadius: stackIndex === stackedData.length - 1 ? 2 : 0,
        groupIndex: groupVars.indexOf(original.group),
        barIndex: barVars.indexOf(original.bar),
        errorType: stack.key
      });
    });
  });
  console.log(chartData);

 const xAxis = d3.axisBottom(xGroupScale).tickSizeOuter(0);
  // Axes
  mySvg.append('g')
  .attr('class', 'xAxis' + myClass)
  .attr('transform', 'translate(' + margins.left + ',' + (height - margins.bottom) + ')')
  .call(xAxis)

  mySvg.select('.xAxis' + myClass)
  .selectAll("text")
  .style("text-anchor", "middle")
  .attr('fill', '#101D42')
  .attr('font-weight', '500')
  .attr('font-size', 10)
  .attr('font-family', 'Poppins')
  .text((d: any) => d)
  .call(wrap, xGroupScale.bandwidth() );

// Hide axis lines and ticks
mySvg.select('.xAxis' + myClass)
  .call((g: any) =>
    g.selectAll('.tick line').attr('display', 'none')
  )
  .call((g: any) =>
    g.selectAll('path').attr('display', 'none')
  );

  mySvg.append('g')
    .attr('class', 'yAxis' + myClass)
    .attr('fill', '#101D42')
  .attr('font-weight', '500')
  .attr('font-size', '12')
  .attr('font-family', 'Poppins')
    .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')')
    .call(d3.axisLeft(yScale).ticks(5))
    .call((g:any) =>
      g.selectAll(".tick line")
      .attr("x2", width - margins.left - margins.right)
      .attr("stroke-dasharray", "2,2")
      .attr("stroke", "#ccc"))
      .call((g:any) =>
      g.selectAll("path")
      .attr("display", 'none')
      );

  mySvg.select('.yAxis' + myClass)
    .selectAll("text")
    .style("text-anchor", "middle")
    .attr('fill', '#101D42')
    .attr('font-weight', '500')
    .attr('font-size', 10)
    .attr('font-family', 'Poppins')
    .text((d: any) => d + (this.props?.surfix||''))
//  drawMiniChart(chartData);
  // Bars
  const barGroup = mySvg.selectAll('.chartGroup' + myClass)
    .data(chartData)
    .enter().append('g').attr('class', 'chartGroup' + myClass);

  const barWidth = xBarScale.bandwidth();
barGroup.append('text').attr('class', 'barValue')
 .attr('fill',(d: any) => d.fill )
 .attr('x',barWidth/2)
 .attr('text-anchor', 'middle')
 .style("font-size", (barWidth/2.5)>40?40:(barWidth/2.5))
 .style("font-family", "Poppins")
 .style("font-weight", 500)
 .text((d:any)=> d.totalValue + (this.props?.surfix||''))
 .attr('transform',(d: any) => 'translate(' + (margins.left +  xGroupScale(d.group) + xBarScale(d.bar) )
 + ',' + (margins.top + (yScale(d.totalValue) + d.extraY-5)) + ')');

  barGroup.append('path')
    .attr('class', 'barRect')
    .attr('d', (d: any) =>
      'M0,' + d.height + 'L0,' + d.borderRadius +
      ' Q0,0 ' + d.borderRadius + ',0 L' + (barWidth - d.borderRadius) +
      ',0 Q' + barWidth + ',0 ' + barWidth + ',' + d.borderRadius +
      ' L' + barWidth + ',' + d.height + 'Z')
    .attr('fill', (d: any) => d.fill)
    .attr('stroke-width', 0)
    .attr('transform', (d: any) =>
      'translate(' + (margins.left +  xGroupScale(d.group) + xBarScale(d.bar)) + ',' +
      (margins.top + (yScale(d.totalValue) + d.extraY)) + ')')
       .on("mousemove", (event: any, d: any) => {
        // debugger
     let tooltipData:any;
      // if (myChart.props.stackEnable) {
        tooltipData = chartData.filter((f: any) => f.group === d.group);
        tooltipData = tooltipData.sort((a: any,b: any) =>  a.bar == d.bar ? -1 : b.bar == d.bar ? 1 : 0);
    //  }
     myChart.showTooltip('bar', tooltipData, event.offsetX, event.offsetY, clientWidth, height);
   })
   .on("mouseout", () => {
     myChart.hideTooltip('bar');
   })

  if (myChart.props.showLegend) {
    drawLegend(Object.keys(myChart.props.barFill));
  }


function drawMiniChart(chartData: any[]) {
  const miniHeight = 60;
  const miniMarginTop = height - margins.bottom + 40;
  const miniGroup = mySvg.select('.miniChart' + myClass)
    .attr('transform', `translate(${margins.left},${miniMarginTop})`);

  const xMiniScale = d3.scaleBand()
    .domain(groupVars)
    .range([0, width - margins.left - margins.right])
    .padding(0.3);

  const yMiniScale = d3.scaleLinear()
    .domain([0, yMax])
    .range([miniHeight, 0]);

  // Draw mini bars
  miniGroup.selectAll('rect')
    .data(chartData.filter(d => d.errorType === stackVars[stackVars.length - 1] || !myChart.props.stackEnable))
    .join('rect')
    .attr('x', (d:any) => xMiniScale(d.group))
    .attr('y', (d:any) => yMiniScale(d.totalValue))
    .attr('width', xMiniScale.bandwidth())
    .attr('height', (d:any) => miniHeight - yMiniScale(d.totalValue))
    .attr('fill', (d:any) => d.fill)
    .attr('opacity', 0.6);

  // Brush
  const brush = d3.brushX()
    .extent([[0, 0], [width - margins.left - margins.right, miniHeight]])
    .on('brush end', brushed);

  mySvg.select('.brush' + myClass)
    .attr('transform', `translate(${margins.left},${miniMarginTop})`)
    .call(brush);

  function brushed({ selection }: any) {
    if (!selection) return;
    const [x0, x1] = selection;

    const visibleGroups = groupVars.filter((g:any) => {
      const x = xMiniScale(g)! + xMiniScale.bandwidth() / 2;
      return x >= x0 && x <= x1;
    });

    xGroupScale.domain(visibleGroups);

    mySvg.select('.xAxis' + myClass)
      .transition().duration(300)
      .call(d3.axisBottom(xGroupScale).tickSizeOuter(0));

    // Re-draw main bars
    const updatedBarWidth = xBarScale.bandwidth();

    mySvg.selectAll('.chartGroup' + myClass)
      .data(chartData.filter(d => visibleGroups.includes(d.group)))
      .join(
        (enter:any) => enter.append('g').attr('class', 'chartGroup' + myClass),
        (update:any) => update,
        (exit:any) => exit.remove()
      )
      .selectAll('.barRect')
      .data((d:any) => [d])
      .join('path')
      .attr('class', 'barRect')
      .attr('d', (d: any) =>
        'M0,' + d.height + 'L0,' + d.borderRadius +
        ' Q0,0 ' + d.borderRadius + ',0 L' + (barWidth - d.borderRadius) +
        ',0 Q' + barWidth + ',0 ' + barWidth + ',' + d.borderRadius +
        ' L' + barWidth + ',' + d.height + 'Z')
      .attr('fill', (d: any) => d.fill)
      .attr('stroke-width', 0)
      .attr('transform', (d: any) =>
        'translate(' + (margins.left + xGroupScale(d.group) + xBarScale(d.bar)) + ',' +
        (margins.top + (yScale(d.totalValue) + d.extraY)) + ')');
  }
}

  function drawLegend(legendData: any) {
    const legendGroup = mySvg
      .selectAll('.legendGroup' + myClass)
      .data(legendData)
      .join((group: any) => {
        const enter = group.append('g').attr('class', 'legendGroup' + myClass);
        enter.append('circle').attr('class', 'legendCircle');
        enter.append('text').attr('class', 'legendLabel');
        return enter;
      });

    // legendGroup.attr("transform", "translate(" + (margins.left + 36) + ",15)");

    legendGroup.select('.legendCircle')
      .attr('id', (d: any) => 'circle_legendItem' + d)
      .attr('fill', (d: any) => myChart.props.barFill[d])
      .attr('r', 4);

    legendGroup.select('.legendLabel')
      .attr('id', (d: any) => 'legendItem' + d)
      .attr('y', 5)
      .attr('fill', '#101D42')
      .attr('font-weight', '500')
      .attr('font-size', '12')
      .attr('font-family', 'Poppins')
      .text((d: any) => myChart.props.barLabels[d]?.toUpperCase());

    let legendX = 0;
    mySvg.selectAll('.legendLabel').each(function (): any {
      //@ts-ignore
      const myObject = this;
      const myWidth: any = document.getElementById(myObject.id)?.getBoundingClientRect().width;
      d3.select(myObject).attr('x', legendX + 12);
      mySvg.select('#circle_' + myObject.id).attr('cx', legendX);
      legendX += (40 + myWidth);
    });
      legendGroup.attr('transform', 'translate(' + ((clientWidth - legendX + 24) / 2)+ ',10)');
    
  }
      function wrap(textSelection: any, wrapWidth: any): void {
           textSelection.each(function(): any {
             //@ts-ignore
             const el = d3.select(this);
             const words = el.text().split(/\s+/).filter((w: string) => w.length > 0);
             if (!words.length) return;

             const lineHeight = 11;
             const dy = 22;
             let lineNumber = 0;
             let line: string[] = [];

             el.text(null);
             let tspan: any = el.append('tspan').attr('x', 0).attr('y', -9).attr('dy', dy + 'px');

             for (const word of words) {
               line.push(word);
               tspan.text(line.join(' '));
               if (tspan.node().getComputedTextLength() > wrapWidth && line.length > 1) {
                 line.pop();
                 tspan.text(line.join(' '));
                 lineNumber++;
                 line = [word];
                 tspan = el.append('tspan').attr('x', 0).attr('y', -9).attr('dy', lineNumber * lineHeight + dy + 'px').text(word);
               }
             }
           });
         }
             this.stop(10).then(() => this.isLoading = false);
}
getSmallBarChartData() {
    this.SmallBarChartData =this.data
     let cgf:any = this.item?.config
    const barFill:any = {};
    const barLabels:any = {};
    
    // Populate the objects dynamically
    cgf?.bar_Fill?.values?.forEach((item:any) => {
        barFill[item.col_value] = item.color;  // Assign the color to barFill
        barLabels[item.col_value] = item?.col_label ? item.col_label :  item.col_value;  // Assign the col_value as the label
    });
    this.props = {
      chartHeight: 500,
      groupVar: cgf?.x_axis?.['api_resp_column_nm']||'source_name',
      barVar: cgf?.cluster_var?.['api_resp_column_nm']||'category_name',
      yVar:cgf?.y_axis?.['api_resp_column_nm'] ||'count',
      stackVar:cgf?.stacked_var?.['api_resp_column_nm']|| null,//'error_type',
      stackEnable: cgf?.stacked_bar?.valuefalse,
      stackColors: ['#2196f3', '#9c27b0', '#00bcd4','#0a3a6a','#828ca2', 'blue', 'gold'],
      clusterColors: ['#0a3a6a','#828ca2','#2196f3', '#9c27b0', '#00bcd4'],
      barFill: barFill||{'dispense': '#0a3a6a', 'patients': '#828ca2', },
      barLabels: barLabels||{"dispense": 'Dispenses', "patients": 'Patients'},
      showLegend: true,
      surfix: this.item?.config?.['surfix'] || ''
    };

    if (this.SmallBarChartData && this.SmallBarChartData.length > 0) {
      this.plotChart();
      this.noData = false
    }else {
      this.noData = true
      this.stop(10).then(() => this.isLoading = false);
    }
  
}
 removeUnderScore(value: string) {
    return value.replace(/_/g, ' ').toUpperCase()
  }

  numbedPipe(value: any) {
    return this.currency.transform(value, '', '', '1.0-2') + (this.props?.surfix||'');
  }
}
